<!-- calendar source: https://codesandbox.io/s/monthly-calendar-vue-wdv9y -->

<template>
    <vs-card>
        <CalendarMonth :refreshEvent="refreshData" @finished="refreshDone" />
    </vs-card>
</template>

<script>
    import CalendarMonth from "../../components/calendar/CalendarMonth";

    export default {
        name: "daily_menu",
        data() {
            return {
                addModal: false,
                refreshData: false
            }
        },
        components: {CalendarMonth},
        methods: {
            closeModal() {
                this.addModal = false;
                this.refreshData = true;
            },
            addMenuItem() {
                this.addModal = true;
            },
            refreshDone() {
                this.refreshData = false;
            }
        }
    }
</script>